/**
 * Customer outcomes, directly under the hero. Each number is an attributed,
 * customer-approved story — never an invented platform statistic.
 */
const proof = [
  { figure: '5–7 days → 2–3', line: 'How long buyers took to decide, before and after.', who: 'Tamerlane Trading' },
  { figure: '$223,674 a year', line: 'One buyer, quiet for six years, back through the morning brief.', who: 'Tamerlane Trading' },
  { figure: '15 minutes', line: 'To set up on his own, no demo needed.', who: 'Independent broker, Canada' },
  { figure: '$25,000 deal', line: 'From pre-rolls that otherwise wouldn’t have been listed.', who: 'Seller, Canada' },
];

const ProofBar = () => (
  <section aria-label="Customer results" className="border-b border-border bg-subtle">
    <dl className="container-wide grid gap-8 py-10 sm:grid-cols-2 lg:grid-cols-4">
      {proof.map((p) => (
        <div key={p.figure}>
          <dt className="num-id text-2xl font-semibold tracking-tight">{p.figure}</dt>
          <dd className="mt-2 text-sm text-foreground/80">{p.line}</dd>
          <dd className="mt-1 text-xs text-muted-foreground">{p.who}</dd>
        </div>
      ))}
    </dl>
  </section>
);

export default ProofBar;
